
import { VSF_LOCALE_COOKIE } from '~~/constants/core-constants';
import { getPrefixedSlug } from '~~/helpers/routes/prefixes';
import localizationDefinitions from '~~/i18n/localizationDefinitions';

export default defineNuxtRouteMiddleware((to) => {

  if (import.meta.server) {

    return;

  }

  const localeCookie = useCookie<string | null>(VSF_LOCALE_COOKIE);
  const languageAndCountry = localeCookie.value ?? '';

  const countryLocalization = localizationDefinitions.getByLanguageAndCountry(languageAndCountry);
  const languagePrefix = countryLocalization
    ?.getLanguageFromExistingLanguageAndCountry(languageAndCountry)
    ?? '';

  // Keep URL style consistent with `prefix-checker`: default language should NOT be prefixed.
  // Otherwise we can end up in a redirect ping-pong:
  // localize-url adds `/de/...` -> prefix-checker redirects to `/...` -> localize-url adds again.
  if (countryLocalization && languagePrefix && countryLocalization.isDefaultLanguage(languagePrefix)) {

    return;

  }

  const prefixedFullPath = getPrefixedSlug(to.fullPath, languagePrefix);
  
  if (prefixedFullPath && prefixedFullPath !== to.fullPath) {

    return navigateTo(prefixedFullPath, { replace: true });

  }

  return;

});
